const isDevelopment = process.env.NODE_ENV === 'development';
const DEV_API_URL = 'http://localhost';
const PROD_API_URL = 'https://esportesa.com.br/api'; // Ajustado para /api/
const API_BASE_URL = isDevelopment ? DEV_API_URL : PROD_API_URL;

export default API_BASE_URL;